export function mapFilterType(type) {
  switch (type) {
    case 1:
    case "Number":
      return "Number";

    case 2:
    case "Select":
      return "Select";

    case 3:
    case "MultiSelect":
      return "MultiSelect";

    case 4:
    case "Text":
      return "Text";

    case "WorkTime":
      return "WorkTime";
      
    default:
      return "Select"; // безопасный fallback
  }
}